import { Style, Fill, Stroke, Circle } from 'ol/style';
import StrokePattern from "ol-ext/style/StrokePattern";
import { IStyleCache, CoreLayerConfig } from '../../Models/MapConfigModels';
import { Feature } from 'ol';
import { MultiPoint } from 'ol/geom';
import VectorLayer from 'ol/layer/Vector';

export class LandMapStyles {
    // Private variables
    private defaultOverridePolyStyle = new Style({ stroke: new Stroke({ color: 'rgba(208, 78, 247, 1)', width: 3 }), fill: new Fill({ color: 'rgba(245, 221, 253, 0.4)' }) });
    private wfsAttributeNames: Array<string> = [];

    // Public variables
    public enabledLandTracingNodes: Boolean = false;
    public landStyleCache: Array<IStyleCache> = [];

    // INIT
    public init(config: Array<CoreLayerConfig>) {
        const self = this;

        self.landStyleCache = [];
        config.forEach(c => {
            if (c.symbologyItem != null) {
                c.symbologyItem.forEach(i => {
                    var s: IStyleCache = { symbologyKey: c.symbologyKey, wfsAttributeName: i.wfsAttributeName, attributeLabel: i.attributeLabel, attributeAltLabel: i.attributeAltLabel, attributeValue: i.attributeValue, showInLegend: i.showInLegend, style: null };

                    var stroke = null; var fill = null;
                    if (i.stroke != null) {
                        stroke = new Stroke({ color: i.stroke.strokeColor, width: i.stroke.width});
                        if (i.stroke.fillColor != null) fill = new Fill({ color: i.stroke.fillColor });
                        if (i.stroke.lineDash != null) {
                            var ld = i.stroke.lineDash.split(",");
                            if (ld && ld.length == 2) stroke.setLineDash(ld as any);
                        }
                    }

                    s.style = new Style({ stroke: stroke, fill: fill });

                    if (self.wfsAttributeNames.indexOf(s.wfsAttributeName) == -1) self.wfsAttributeNames.push(s.wfsAttributeName);

                    self.landStyleCache.push(s);
                });
            }
        });
    }

    public landStyleFunction = (feature: Feature, resolution, vectorLayer: VectorLayer, self): Style[] => {
        const me = self == null ? this : self.mapStyles.LandMapStyles; // This is because the function is being called through OpenLayers, so seld refers to MapLayerHelper
        var styles: Array<Style> = [];

        // Search wfsAttributes
        const symbologyKey = vectorLayer.get('symbologyKey');
        var styleCache;
        if (symbologyKey != null) styleCache = me.landStyleCache.filter(s => s.symbologyKey == symbologyKey);
        else styleCache = me.landStyleCache;
        
        // Search wfsAttributes
        me.wfsAttributeNames.forEach(k => {
            var v = feature.get(k);
            if (v != null) {
                // Check to see if the wfsAttribute is mentioned in the style cache
                if (styleCache.find(s => s.wfsAttributeName == k) != null) {
                    // If the wfsAttribute is in the style cache, now check to see if the feature has that value
                    var s = styleCache.find(s => s.wfsAttributeName == k && s.attributeValue == v);
                    if (s != null) styles.push(s.style); // If it does, use the style
                }
            }
        });
        if (styles.length == 0) {
            var s = styleCache.find(f => f.attributeLabel.toLowerCase() == 'default');
            if (s != null) styles.push(s.style);
            if (styles.length == 0) styles.push(me.defaultOverridePolyStyle);
        }

        // Only add in these nodes if the user has enabled tracing
        if (me.enabledLandTracingNodes == true) {
            var style = new Style({
                image: new Circle({
                    radius: 5,
                    stroke: new Stroke({ color: 'orange', width: 1 })
                }),
                geometry: function (feature) {
                    // return the coordinates of the geometry as a MultiPoint, if this is a polygon then return the first ring 
                    var coordinates: Array<any> = (feature.getGeometry() as any).getCoordinates();
                    if (feature.getGeometry().getType() == "Polygon" || feature.getGeometry().getType() == "MultiPolygon") {
                        coordinates = [];
                        (feature.getGeometry() as any).getCoordinates().forEach(
                            c => { coordinates = coordinates.concat(c); }
                        );
                    }
                    return new MultiPoint(coordinates);
                }
            })

            styles.push(style);
        };

        return styles;
    }
}




